document.addEventListener('DOMContentLoaded', () => {
  const marqueeContent = document.querySelector('.home-hero__icons-inner');
  let animationFrameId;
  let currentPosition = 0;
  let speed = window.innerWidth <= 1199 ? 0.5 : 0.5;

  const items = marqueeContent.children;
  const itemCount = items.length;

  for (let i = 0; i < 3; i++) {
    for (let j = 0; j < itemCount; j++) {
      const clone = items[j].cloneNode(true);
      marqueeContent.appendChild(clone);
    }
  }

  const firstSetWidth = Array.from(items)
    .slice(0, itemCount)
    .reduce((total, item) => {
      return total + item.offsetWidth + 70;
    }, 0);

  function animate() {
    currentPosition -= speed;

    if (currentPosition <= -firstSetWidth) {
      currentPosition = 0;
    }

    marqueeContent.style.transform = `translateX(${currentPosition}px)`;
    animationFrameId = requestAnimationFrame(animate);
  }

  animate();

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      speed = window.innerWidth <= 1199 ? 0.5 : 0.5;
    }, 250);
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      cancelAnimationFrame(animationFrameId);
    } else {
      animate();
    }
  });
});
